/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-27 16:30:11
 * @LastEditTime: 2019-10-30 00:27:04
 * @LastEditors: he.jianbo
 */
/**
 * description: 微博创建
 * author: Qian.qianchen 2018-11-19
 */
'use strict';
angular.module('weiboCreateModule', []).controller('weiboCreateCtrl', [
    '$scope',
    '$state',
    'Upload',
    'modalDialog',
    'item',
    'trsHttpService',
    'editingCenterWeiBoService',
    'editingCenterService',
    '$q',
    'sensitiveWordCheckService',
    '$modalInstance',
    '$validation',
    '$timeout',
    'flowStatus',
    'editcenterRightsService',
    'weiboApiParams',
    function(
        $scope,
        $state,
        Upload,
        modalDialog,
        item,
        trsHttpService,
        editingCenterWeiBoService,
        editingCenterService,
        $q,
        sensitiveWordCheckService,
        $modalInstance,
        $validation,
        $timeout,
        flowStatus,
        editcenterRightsService,
        weiboApiParams
    ) {
        initStatus();
        initEditData();

        /**
         * [initStatus 创建微博]
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                params: angular.extend({}, weiboApiParams.saveParams, {
                    AccountIds: angular.isDefined($state.params.wbchannelid) ? $state.params.wbchannelid : item.PUBLISHACCOUNTIDS,
                }),
                docItem: item,
                isCheckSensitiveWords: false,
                emojiShow: false,
                emojiItem: '',
                lastPictures: 9,
                sensitiveWords: '',
                windowTit: item == 0 ? '创建微博' : '编辑微博',
                isInitFdg: false,
                flowStatus: flowStatus,
                btnRights: {},
            };
            $scope.data = {
                content: '',
                pictures: [],
                $files: [],
                // video:"",
                // videoUrl:""
            };
        }

        /**
         * [initEditData description] 微博编辑信息初始化
         * @return {[type]} [description]
         */
        function initEditData() {
            initBtnRights();
            if ($scope.status.docItem != 0) {
                $scope.status.params.ObjectId = $scope.status.docItem.SCMMICROCONTENTID;
                $scope.data.content = $scope.status.docItem.CONTENT;
                $scope.data.pictures = angular.isDefined($scope.status.docItem.PICTURE)
                    ? $scope.status.docItem.PICTURE.map(function(currVal) {
                        return {
                            imgName: currVal,
                            imgSrc: '/wcm/app/scm/file/read_image.jsp?FileName=' + currVal,
                        };
                    })
                    : [];
                $scope.status.lastPictures = 9 - $scope.data.pictures.length;
                $scope.status.params.isContainSensitiveWords = $scope.status.docItem.ISCONTAINSENSITIVEWORDS;
                $scope.status.params.Source = $scope.status.docItem.SOURCE;
            }
        }

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService
                .initWeiboListBtn(
                    flowStatus == '40' ? 'microblog.daibian' : 'microblog.daishen',
                    angular.isUndefined($state.params.wbchannelid) ? $scope.status.docItem.PUBLISHACCOUNTIDS : $state.params.wbchannelid
                )
                .then(function(rights) {
                    $scope.status.btnRights = rights;
                });
        }

        /**
         * [save description] 保存微博
         * @param  {[boolean]} isFinished [description]是否完成
         * @return {[type]} [description]
         */
        function save(isFinished) {
            var deferred = $q.defer();
            $scope.contentForm.$pending = {};
            $validation.validate($scope.contentForm).success(function() {
                deferred.reject();
            });
            return deferred.promise;
        }

        /**
         * [initFdgInfo 初始化发稿单信息]
         *
         * @return  {[type]}  [return description]
         */
        function initFdgInfo() {
            var deferred = $q.defer();
            if (!$scope.status.isInitFdg) {
                getCurrentLoginUser().then(function(data) {
                    data[0].TYPE = '21';
                    $scope.status.params.FGD_AUTHINFO = JSON.stringify(data);
                    $scope.status.params.FGD_EDITINFO = '[]';
                    $scope.status.params.DOCGENRE = JSON.stringify({ name: '无体裁', value: '无体裁' });
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        /**
         * [getCurrentLoginUser description] 获取当前登录用户信息
         * @return {[type]} [description]
         */
        function getCurrentLoginUser() {
            var deferred = $q.defer();
            var userParams = {
                serviceid: 'mlf_extuser',
                methodname: 'findUserInfo',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), userParams, 'post').then(function(data) {
                deferred.resolve(data);
            });
            return deferred.promise;
        }

        /**
         * [isCheckSensitiveWordsToggle description] 敏感词校验开启/关闭
         * @return {[type]} [description]
         */
        $scope.isCheckSensitiveWordsToggle = function() {
            $scope.status.isCheckSensitiveWords = !$scope.status.isCheckSensitiveWords;
        };

        /**
        * [addEmoji 添加表情]
        *
        * @param   {[type]}  item  [item description]
        *
        * @return  {[type]}        [return description]
        */
        $scope.addEmoji = function(item) {
            var $t = document.getElementById('input_content');
            var startPos = $t.selectionStart;
            var endPos = $t.selectionEnd;
            $scope.data.content =
                $scope.data.content.substring(0, startPos) + item.value + $scope.data.content.substring(endPos, $scope.data.content.length);

            $timeout(function() {
                $t.selectionStart = $t.selectionEnd = startPos + item.value.length;
                $t.focus();
            });
        };

        /**
         * [addTopic 添加话题]
         *
         * @return  {[type]}  [return description]
         */
        $scope.addTopic = function() {
            var $t = document.getElementById('input_content');
            var startPos = $t.selectionStart;
            var endPos = $t.selectionEnd;
            $scope.data.content =
                $scope.data.content.substring(0, startPos) + '##' + $scope.data.content.substring(endPos, $scope.data.content.length);

            $timeout(function() {
                $t.selectionStart = $t.selectionEnd = startPos + 1;
                $t.focus();
            });
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            if ($scope.status.params.ObjectId != 0) {
                editingCenterWeiBoService.unlockWeibo(JSON.parse($scope.status.params.ObjectId));
            }
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            save(true);
        };

        /**
         * [timingSign description] 表单信息提交-定时签发
         * @return {[type]} [description]
         */
        $scope.timingSign = function() {
            $scope.contentForm.$pending = {};
            $validation.validate($scope.contentForm).success(function() {
                $scope.status.params.Content = $scope.data.content;
                $scope.status.params.Picture = $scope.data.pictures
                    .map(function(picture) {
                        return picture.imgName;
                    })
                    .join(',');
                initFdgInfo()
                    .then(function() {
                        return sensitiveWordCheckService.sensitiveWords($scope);
                    })
                    .then(function(sensitiveWords) {
                        $scope.status.params.isContainSensitiveWords = !!sensitiveWords.length ? 1 : 0;
                        $scope.status.sensitiveWords = sensitiveWords;
                    });
                var item = angular.copy($scope.status.params);
                item.ObjectIds = item.ObjectId;
                delete item.ObjectId;
                editingCenterWeiBoService.timeSignWeibo([item], true, $scope.status.flowStatus, function(result) {
                    if (result == 'success') {
                        if ($scope.status.params.ObjectId != 0) {
                            editingCenterWeiBoService.unlockWeibo(JSON.parse($scope.status.params.ObjectId));
                        }
                        $modalInstance.close('successTimeSign');
                    } else {
                        modalDialog.alertType('该微博保存成功，定时签发失败！', result.result.detail, 'error', 'confirm', function() {});
                        $modalInstance.close();
                    }
                });
            });
        };

        /**
         * [trial description] 表单信息提交-送审
         * @return {[type]} [description]
         */
        $scope.trial = function() {
            $scope.contentForm.$pending = {};
            $validation.validate($scope.contentForm).success(function() {
                modalDialog.alertType('送审', '是否确认送审此微博', 'ask', true, function() {
                    save(false).then(function(docid) {
                        let params = {
                            ObjectIds: docid,
                        };
                        $scope.loadingPromise = editingCenterWeiBoService.trail(params).then(
                            (data) => {
                                editingCenterWeiBoService.unlockWeibo(JSON.parse(docid));
                                if (angular.isDefined(data[0].ISLOCK)) {
                                    $modalInstance.close('successTrial');
                                }
                            },
                            function(data) {
                                modalDialog.alertType(
                                    '该微博保存成功，送审失败！',
                                    result.detail == '' ? result.message : result.detail,
                                    'error',
                                    'confirm',
                                    function() {}
                                );
                                $modalInstance.close();
                            }
                        );
                    });
                });
            });
        };

        /**
         * [directSign description] 表单信息提交-直接签发
         * @return {[type]} [description]
         */
        $scope.directSign = function() {
            $scope.contentForm.$pending = {};
            $validation.validate($scope.contentForm).success(function() {
                $scope.status.params.Content = $scope.data.content;
                if ($scope.data.videoUrl !== '') {
                    $scope.status.params.video = $scope.data.videoUrl;
                    $scope.status.params.videoTitle = $scope.data.content;
                } else {
                    $scope.status.params.Picture = $scope.data.pictures
                        .map(function(picture) {
                            return picture.imgName;
                        })
                        .join(',');
                }
                initFdgInfo()
                    .then(function() {
                        return sensitiveWordCheckService.sensitiveWords($scope);
                    })
                    .then(function(sensitiveWords) {
                        $scope.status.params.isContainSensitiveWords = !!sensitiveWords.length ? 1 : 0;
                        $scope.status.sensitiveWords = sensitiveWords;
                    });
                var item = angular.copy($scope.status.params);
                item.ObjectIds = item.ObjectId;
                delete item.ObjectId;
                editingCenterWeiBoService.directSignWeibo([item], true, flowStatus, function(result) {
                    if (result == 'success') {
                        if ($scope.status.params.ObjectId != 0) {
                            editingCenterWeiBoService.unlockWeibo(JSON.parse($scope.status.params.ObjectId));
                        }
                        $modalInstance.close('successDirectSign');
                    } else {
                        modalDialog.alertType('该微博保存成功，直接签发失败！', result.result.detail, 'error', 'confirm', function() {});
                        $modalInstance.close();
                    }
                });
            });
        };

        /**
         * [setSheet 发稿单设置]
         *
         * @return  {[type]}  [return description]
         */
        $scope.setSheet = function() {
            var weiboId, fdgInfo;
            if (angular.isUndefined(item.SCMMICROCONTENTID)) {
                weiboId = 0;
            } else {
                weiboId = item.SCMMICROCONTENTID;
            }
            if ($scope.status.isInitFdg) {
                fdgInfo = {
                    DocGenre: $scope.status.params.DOCGENRE,
                    fgd_editinfo: $scope.status.params.FGD_EDITINFO,
                    fgd_authinfo: $scope.status.params.FGD_AUTHINFO,
                    ISNOPAYMENT: $scope.status.params.ISNOPAYMENT,
                };
            }
            editingCenterService.draftListForFgd(
                weiboId,
                function(params) {
                    $scope.status.isInitFdg = true;
                    $scope.status.params.DOCGENRE = params.DOCGENRE;
                    $scope.status.params.ISNOPAYMENT = params.ISNOPAYMENT;
                    $scope.status.params.FGD_AUTHINFO = params.FGD_AUTHINFO;
                    $scope.status.params.FGD_EDITINFO = params.FGD_EDITINFO;
                },
                fdgInfo
            );
        };

        /**
         * [selectFile description] 上传图片
         * @param  {[type]} $files    [description] 图片文件数组
         * @param  {[type]} $file     [description] 新上传的单张图片
         * @param  {[type]} $newFiles [description] 新上传的文件数组
         * @return {[type]}           [description]
         */
        $scope.selectFile = function() {
            if ($scope.status.lastPictures < $scope.data.$files.length) {
                $scope.data.$files.splice($scope.status.lastPictures, $scope.data.$files.length - $scope.status.lastPictures);
            }
            $scope.data.$files.forEach(function(value, index) {
                value.index = index; //**给进来的文件打好标记，防止顺序错乱
                var reader = new FileReader();
                reader.readAsDataURL(value);
                reader.onload = function(e) {
                    value.imgSrc = e.target.result;
                };
            });
            var time = 0;
            for (var i = 0; i < $scope.data.$files.length; i++) {
                var file = $scope.data.$files[i];
                if (file.size / 1024 / 1024 > 30) {
                    file.error = '文件太大，不得大于30MB';
                    time++;
                    continue;
                }
                uploadPic(file, function() {
                    for (var j = 0; j < $scope.data.$files.length; j++) {
                        var pic = $scope.data.$files[j];
                        $scope.data.pictures.push({
                            imgSrc: pic.imgSrc,
                            imgName: pic.imgName,
                        });
                    }
                    $scope.data.$files = [];
                });
            }

            /**
             * [uploadPic 上传图片]
             *
             * @param   {[type]}  file    [file description]
             * @param   {[type]}  finish  [finish description]
             *
             * @return  {[type]}          [return description]
             */
            function uploadPic(file, finish) {
                Upload.upload({
                    url: '/wcm/openapi/uploadImage',
                    data: {
                        file: file,
                    },
                }).then(
                    function(resp) {
                        if (resp.data.success) {
                            file.imgSrc = resp.data.imgSrc.substring(resp.data.imgSrc.indexOf('/wcm'), resp.data.imgSrc.length);
                            file.imgName = resp.data.imgName;
                        } else {
                            file.error = resp.data.error;
                        }
                        time++;
                        $scope.status.lastPictures--;
                        if (time === $scope.data.$files.length) {
                            finish();
                        }
                    },
                    function(resp) {
                        if (resp.status == '413') {
                            file.error = '文件太大，不得大于30MB!';
                        } else {
                            file.error = '未知错误!';
                        }
                        time++;
                        if (time === $scope.data.$files.length) {
                            finish();
                        }
                    },
                    function(evt) {
                        file.progress = parseInt((evt.loaded / evt.total) * 100) + '%';
                        file.FILEINFO = '上传中';
                    }
                );
            }
        };


        /**
         * [deletePic description] 删除上传的图片
         * @param  {[object]} item [description] 图片对象
         * @return {[type]}      [description]
         */
        $scope.deletePic = function(item) {
            for (var i = 0; i < $scope.data.pictures.length; i++) {
                if (item == $scope.data.pictures[i]) {
                    $scope.data.pictures.splice(i, 1);
                    $scope.status.lastPictures = 9 - $scope.data.pictures.length;
                    return;
                }
            }
        };

        /**
         * [dragoverCallback 允许拖拽]
         *
         * @param   {[type]}  event     [event description]
         * @param   {[type]}  index     [index description]
         * @param   {[type]}  external  [external description]
         * @param   {[type]}  type      [type description]
         *
         * @return  {[type]}            [return description]
         */
        $scope.dragoverCallback = function(event, index, external, type) {
            return true;
        };

        /**
         * [dragStart 拖拽开始]
         *
         * @param   {[type]}  event  [event description]
         * @param   {[type]}  item   [item description]
         * @param   {[type]}  index  [index description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.dragStart = function(event, item, index) {
            $scope.status.dragStartIndex = index;
        };

        /**
         * [dropCallback 拖拽结束]
         *
         * @param   {[type]}  event        [event description]
         * @param   {[type]}  index        [index description]
         * @param   {[type]}  item         [item description]
         * @param   {[type]}  external     [external description]
         * @param   {[type]}  type         [type description]
         * @param   {[type]}  allowedType  [allowedType description]
         *
         * @return  {[type]}               [return description]
         */
        $scope.dropCallback = function(event, index, item, external, type, allowedType) {
            if ($scope.status.dragStartIndex == index) {
                return;
            } else if ($scope.status.dragStartIndex > index) {
                $scope.data.pictures.splice(index, 0, item);
                $scope.data.pictures.splice($scope.status.dragStartIndex + 1, 1);
            } else {
                $scope.data.pictures.splice(index, 0, item);
                $scope.data.pictures.splice($scope.status.dragStartIndex, 1);
            }
        };
    },
]);
